import { UseDialogStateOutput, useDialogState } from '~/hooks/useDialogState';

export type UseEmployeeActionOutput = {
  changeRolesDialog: UseDialogStateOutput;
  changeLoginMethod: UseDialogStateOutput;
  resetPasswordDialog: UseDialogStateOutput;
  changeUserNameDialog: UseDialogStateOutput;
  changeAccountStatusDialog: UseDialogStateOutput;
  cropImageDialog: UseDialogStateOutput;
  activityTrackingDialog: UseDialogStateOutput;
};

export const useEmployeeAction = (): UseEmployeeActionOutput => {
  const changeRolesDialog = useDialogState();
  const changeLoginMethod = useDialogState();
  const resetPasswordDialog = useDialogState();
  const changeUserNameDialog = useDialogState();
  const changeAccountStatusDialog = useDialogState();
  const cropImageDialog = useDialogState();
  const activityTrackingDialog = useDialogState();

  return {
    changeRolesDialog,
    changeLoginMethod,
    resetPasswordDialog,
    changeUserNameDialog,
    changeAccountStatusDialog,
    cropImageDialog,
    activityTrackingDialog,
  };
};
